import { IApiError } from '@/models/apiError.model';
import { IGeneralSettings } from '@/models/settings.model';

export const SETTINGS_SLICE_NAME = 'settings';

export interface SettingsState {
  generalSettings: IGeneralSettings | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: SettingsState = {
  generalSettings: null,
  isLoading: false,
  error: null,
};
